export class TitleService {
  constructor(private _document: Document) {}

  public getTitle(): string {
    return this._document.title;
  }

  public setTitle(newTitle: string): void {
    this._document.title = newTitle;
  }
}
export function provideTitleService(): TitleService {
  return new TitleService(document);
}
